/**
 * Application Configuration
 *
 * Centralized configuration for API keys and app settings.
 * All values are read from environment variables (VITE_* prefix).
 *
 * @see .env.example for required environment variables
 */

export const appConfig = {
    /**
     * Google Maps API key for embedded maps
     * @see https://developers.google.com/maps/documentation/embed/get-api-key
     */
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',

    /**
     * Google Maps Map ID for Advanced Markers and custom styling.
     * Create one at: https://console.cloud.google.com/google/maps-apis/studio/maps
     */
    googleMapsMapId: import.meta.env.VITE_GOOGLE_MAPS_MAP_ID || '',

    /**
     * API base URL (defaults to localhost for development)
     */
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080',

    /**
     * AWS region for CloudWatch console links (Super Admin Toolbar)
     */
    awsRegion: import.meta.env.VITE_AWS_REGION || 'us-east-1',

    /**
     * AWS account ID for constructing CloudWatch log group ARNs
     */
    awsAccountId: import.meta.env.VITE_AWS_ACCOUNT_ID || '',

    /**
     * AWS CloudWatch log group names (Super Admin Toolbar).
     * Only configured log groups appear as shortcuts in the toolbar.
     */
    awsLogGroupApi: import.meta.env.VITE_AWS_LOG_GROUP_API || '',
    awsLogGroupWorker: import.meta.env.VITE_AWS_LOG_GROUP_WORKER || '',
    awsLogGroupEmail: import.meta.env.VITE_AWS_LOG_GROUP_EMAIL || '',

    /**
     * Sentry DSN for error monitoring & performance tracking
     */
    sentryDsn: import.meta.env.VITE_SENTRY_DSN || '',

    /**
     * Sentry Environment tag (defaults to Vite mode e.g. development, production, staging)
     */
    sentryEnvironment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE || 'development',
}

/**
 * Type-safe access to config values
 */
export type AppConfig = typeof appConfig
